<div class="row mt-5">
  <div class="col-12">
    <p class="fw-bold">Track your GL export history in the table below:</p>
  </div>
</div>
<ng-container *ngIf="items != null">
  <div class="row">
    <div class="col-12">
      <table class="table table-connectpay">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Export Date</th>
            <th>Status</th>
            <th>Error</th>
            <th>File</th>
            <th>Created By</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td>
              <button class="btn btn-link-blue p-0 fw-bold" (click)="navigateToConfig(item)">
                {{ item.ConfigName }}
              </button>
            </td>
            <td>{{ item.Created | date: 'short' }}</td>
            <td>
              <span *ngIf="item.Status == 'failure'" class="text-danger fw-bold">
                EXPORT FAILED
              </span>
              <span *ngIf="item.Status == 'success'" class="text-success fw-bold"> SUCCESS </span>
              <span *ngIf="item.Status == 'warning'" class="text-warning fw-bold"> WARNING </span>
            </td>
            <td>{{ item.Error }}</td>
            <td>
              <span *ngIf="item.ExportFileType == GeneralLedgerExportTypes.CSV">CSV</span>
              <span *ngIf="item.ExportFileType == GeneralLedgerExportTypes.QBO">QBO</span>
              <span *ngIf="item.ExportFileType == GeneralLedgerExportTypes.IIF">QB</span>
            </td>
            <td>{{ item.Username }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <small class="d-block fst-italic" *ngFor="let item of errorsToShow"> *{{ item }} </small>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-pagination
        [pagination]="pagination"
        (pageChanged)="pageChanged($event)"></lib-pagination>
    </div>
  </div>
</ng-container>
